import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ListaPropostas from '../ListaPropostas/ListaPropostas';
import configBase from '../../../configBase';
import { Main as MainLayout, } from '../../../layouts';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';



class ListaPropostasFuncEmpresa extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render() {

    return (
      <div>
        {
          configBase.moduloFuncEmpresa === true ? (
        <ListaPropostas history={this.props.history}/>
          ) : (
        <MainLayout history={this.props.history}>
          <div id="listaPropostas" className={{flexGrow: 1}}>
            <Paper elevation={0} className="paper">
              <Typography variant="button" gutterBottom>
                FUNC DE EMPRESA
              </Typography>
            </Paper>

            <Grid container spacing={0} style={{marginTop: 50}}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Alert severity="error">
                  Módulo de Funcionários de Empresa não habilitado. Entre em contato com a Intelite Tecnologia
                </Alert>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
          </div>
        </MainLayout>
          )
        }
      </div>
    );

  }

}

ListaPropostasFuncEmpresa.propTypes = {
  history: PropTypes.object
};

export default withRouter(ListaPropostasFuncEmpresa);